module.exports = __webpack_public_path__ + "media/img/why/payment-3e91f9b86b412e9e5b627e596e32afce.png";